module.exports = __webpack_public_path__ + "static/media/30.fe083b67.mp3";